import { useCompanyConfigQuery } from "../../SWR/Company/useCompanyConfigQuery";
/**
 * Returns value formatted as currency from the company's culture info
 * @param value - the value to format
 * @param treatNegativeAsCredit - (default is false) if true, a negative value will be treated as a credit (positive)
 * @returns
 */
export const useCurrencyLocalizer = (value, treatNegativeAsCredit = false) => {
    const { culture } = useCompanyConfigQuery();
    const numberFormat = new Intl.NumberFormat(culture.cultureInfo, {
        style: "currency",
        currency: culture.currency,
    });
    let currencySymbol;
    numberFormat.formatToParts(0).forEach(({ type, value }) => {
        if (type === "currency") {
            currencySymbol = value;
        }
    });
    let isCredit = null;
    if (treatNegativeAsCredit && value != null) {
        isCredit = value < 0;
    }
    const valueToFormat = treatNegativeAsCredit && isCredit ? Math.abs(value !== null && value !== void 0 ? value : 0) : value !== null && value !== void 0 ? value : 0;
    const localizedCurrencyText = numberFormat.format(valueToFormat);
    return { localizedCurrencyText, currencySymbol, isCredit };
};
